export default __webpack_public_path__ + "static/media/20-travel by cruise.82f2a61a.svg";